import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronDown } from 'lucide-react';
export const HeroSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false);
  const handleBeginJourney = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsScrolling(true);
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setTimeout(() => setIsScrolling(false), 1000);
    }
  };
  return <>
      <section id="hero" className="relative w-full min-h-screen bg-black flex items-center justify-center overflow-hidden" data-id="element-1242">
        {/* Background image */}
        <div className="absolute inset-0" data-id="element-1243">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxKq2k9j3qcBE1TheAWARz/Experience_image.png" alt="Life in the Sikh Kingdoms" className="w-full h-full object-cover opacity-40" data-id="element-1244" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black" data-id="element-1245"></div>
        </div>
        {/* Content */}
        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto" data-id="element-1246">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2
        }} data-id="element-1247">
            <p className="text-amber-400/50 tracking-[0.25em] text-[10px] uppercase mb-3 font-light" data-id="element-1248">
              Presented by Akal Steel
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.3
        }} data-id="element-1249">
            <p className="text-amber-400 tracking-[0.3em] text-xs md:text-sm uppercase mb-8 font-light" data-id="element-1250">
              1799 – 1839 · Lahore Darbar
            </p>
            <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl text-white mb-8 tracking-tight leading-none" data-id="element-1251">
              LIFE IN THE
              <br data-id="element-1252" />
              <span className="text-amber-400" data-id="element-1253">SIKH KINGDOMS</span>
            </h1>
            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-12 text-white/80" data-id="element-1254">
              <div className="text-center" data-id="element-1255">
                <p className="text-sm tracking-[0.2em] uppercase mb-1" data-id="element-1256">
                  Immersive
                </p>
                <p className="text-xs" data-id="element-1257">Dining Experience</p>
              </div>
              <div className="hidden md:block w-px h-12 bg-white/20" data-id="element-1258"></div>
              <div className="text-center" data-id="element-1259">
                <p className="text-sm tracking-[0.2em] uppercase mb-1" data-id="element-1260">
                  From The Court
                </p>
                <p className="text-xs" data-id="element-1261">Of Maharaja Ranjit Singh</p>
              </div>
              <div className="hidden md:block w-px h-12 bg-white/20" data-id="element-1262"></div>
              <div className="text-center" data-id="element-1263">
                <p className="text-sm tracking-[0.2em] uppercase mb-1" data-id="element-1264">
                  Toronto
                </p>
                <p className="text-xs" data-id="element-1265">Summer 2026</p>
              </div>
            </div>
            <motion.a href="#about" onClick={handleBeginJourney} className="group relative inline-block" whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} animate={isScrolling ? {
            y: [0, -10, 0],
            opacity: [1, 0.5, 1]
          } : {}} transition={{
            duration: 0.6,
            ease: 'easeInOut'
          }} data-id="element-1266">
              <div className="relative border-2 border-white/30 hover:border-amber-400 transition-colors duration-300 px-12 py-4" data-id="element-1267">
                <span className="text-white tracking-[0.3em] text-sm uppercase font-light flex items-center gap-3" data-id="element-1268">
                  Begin Journey
                  <motion.div animate={{
                  y: [0, 3, 0]
                }} transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-1269">
                    <ChevronDown className="w-4 h-4" data-id="element-1270" />
                  </motion.div>
                </span>
                <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-amber-400 group-hover:w-full transition-all duration-500" data-id="element-1271"></div>
              </div>
            </motion.a>
          </motion.div>
        </div>
        {/* Scroll indicator */}
        <motion.div className="absolute bottom-8 left-1/2 transform -translate-x-1/2" animate={{
        y: [0, 10, 0]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} data-id="element-1272">
          <div className="w-px h-16 bg-gradient-to-b from-transparent via-white/50 to-transparent" data-id="element-1273"></div>
        </motion.div>
      </section>
      {/* Expanded Modal */}
      <AnimatePresence data-id="element-1274">
        {isExpanded && <motion.div className="fixed inset-0 z-50 bg-black" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} data-id="element-1275">
            <button onClick={() => setIsExpanded(false)} className="absolute top-8 right-8 z-50 text-white hover:text-amber-400 transition-colors" data-id="element-1276">
              <X className="w-8 h-8" data-id="element-1277" />
            </button>
            <div className="w-full h-full flex items-center justify-center p-8" data-id="element-1278">
              <motion.div className="max-w-7xl w-full" initial={{
            scale: 0.9,
            opacity: 0
          }} animate={{
            scale: 1,
            opacity: 1
          }} transition={{
            duration: 0.5
          }} data-id="element-1279">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pxKq2k9j3qcBE1TheAWARz/Experience_image.png" alt="Life in the Sikh Kingdoms - Full View" className="w-full h-auto object-contain" data-id="element-1280" />
                <motion.div className="text-center mt-8" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3
            }} data-id="element-1281">
                  <p className="text-white/60 text-sm tracking-wider" data-id="element-1282">
                    Illuminarium Toronto · Distillery District
                  </p>
                </motion.div>
              </motion.div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
};